import useConnectivityPort from '@UI/Providers/PortsProvider/Hooks/Connectivity/useConnectivityPort';
import * as React from 'react';

/**
 * Reflects the connectivity port's reading through `useSyncExternalStore`. `isOnline` is a
 * primitive, so it compares stably across renders on its own — there is nothing here to memoize.
 */
function useConnectivity(): boolean {
	const connectivityPort = useConnectivityPort();

	const subscribe = React.useCallback(
		(onStoreChange: () => void): (() => void) => connectivityPort.subscribe(() => onStoreChange()),
		[connectivityPort],
	);

	const getSnapshot = React.useCallback(
		(): boolean => connectivityPort.current().isOnline,
		[connectivityPort],
	);

	return React.useSyncExternalStore(subscribe, getSnapshot);
}

export default useConnectivity;
